<template>
    <main>
        <div class="services-section">
            <div class="services-section-copy">
                <span class="hide-sp">あなたの</span> 理想のキャリアに合わせた<span class="hide-sp">、</span>３つのサービス
            </div>
            <ul class="services-list">
                <li class="services-item services-engineer">
                    <div class="services-item-image"></div>
                    <div class="services-item-description">
                        <div class="services-item-description-content">
                            <div class="services-item-description-logo">
                                <img src="@/assets/engineer-logo-fill-02-512b5fb94b24697b4af82219a7f43a62.png" alt="">
                            </div>
                            <p class="services-item-description-title">エンジニアになりたい方</p>
                        </div>
                        <div class="services-item-description-btn">
                            詳細はこちら
                        </div>
                    </div>
                </li>
                <li class="services-item services-programmer">
                    <div class="services-item-image"></div>
                    <div class="services-item-description">
                        <div class="services-item-description-content">
                            <div class="services-item-description-logo">
                                <img src="@/assets/programming-logo-fill-02-8fc876fce360b38b5d82db3bea5b8f44.png" alt="">
                            </div>
                            <p class="services-item-description-title">プログラミングを理解したい方</p>
                        </div>
                        <div class="services-item-description-btn">
                            詳細はこちら
                        </div>
                    </div>
                </li>
                <li class="services-item services-designer">
                    <div class="services-item-image"></div>
                    <div class="services-item-description">
                        <div class="services-item-description-content">
                            <div class="services-item-description-logo">
                                 <img src="@/assets/designer-logo-fill-02-f5d1848852c402614cdd84387b798c02.png" alt="">
                            </div>
                            <p class="services-item-description-title">デザイナーになりたい方</p>
                        </div>
                        <div class="services-item-description-btn">
                            詳細はこちら
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </main>
</template>

<script>
export default {
    name: 'Main',
}
</script>

<style scoped>
    .services-section {
        padding: 0 150px;
    }

    .services-item-description-logo img {
        display: block;
        height: 44px;
        margin: 0 auto;
    }

    .services-engineer .services-item-image{
        background-image: url(../assets/firstview-engineer-d95aeb290d5d04e34ce20d6fdf3ff8a5.jpg);
        border-radius: 50%;
        width: 220px;
        height: 220px;
        background-size: cover;
        background-position: center;
        margin: 0 auto;
    }

    .services-programmer .services-item-image{
        background-image: url(../assets/firstview-kyoyo-14d5cb048bbbf75451583a00ea4ef7ff.jpg);
        border-radius: 50%;
        width: 220px;
        height: 220px;
        background-size: cover;
        background-position: center;
        margin: 0 auto;
    }

    .services-designer .services-item-image{
        background-image: url(../assets/firstview-design-751944026e720e4a8b1a777422a70de6.jpg);
        border-radius: 50%;
        width: 220px;
        height: 220px;
        background-size: cover;
        background-position: center;
        margin: 0 auto;
    }

    .services-item-image {
        height: 350px;
        background-size: cover;
    }

    .services-section-copy {
        text-align: center;
        padding: 20px 15px;
        font-size: 1.5rem;
    }

    .services-item-description-title {
        font-size: 1.3rem;
        margin: 0 10px;
    }

    .services-item .services-item-description-btn {
        background-color: #11376b;
        margin: 20px auto;
        text-align: center;
        padding: 0 40px;
        line-height: 44px;
        width: 100px;
        color: #fff;
        border-radius: 22px;
    }

    .services-item li {
        width: calc(100%/3);
    }

    .services-list {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        border-bottom: 1px solid #ddd;
    }

    ul {
        list-style: none;
    }

    @media screen and (max-width: 767px){
    p {
       font-size: .9rem;
       letter-spacing: 0; 
    }

    .services-section-copy {
        font-size: .9rem;
    }

    .services-list {
        flex-direction: column;
    }

    .services-item li{
        width: 100%;
        display: flex;
    }

    .services-programmer .services-item-image {
        width: 180px;
        height: 180px;
    }

    .services-engineer .services-item-image {
        width: 180px;
        height: 180px;
    }

    .services-designer .services-item-image {
        width: 180px;
        height: 180px;
    }
    }
</style>